module.exports = __webpack_public_path__ + "img/spoken_save_tip.cb9453ff.svg";